import {
  DOWNLOAD_XML_ERROR_INVOICES,
  DOWNLOAD_XML_ERROR_INVOICES_FAIL,
  DOWNLOAD_XML_ERROR_INVOICES_SUCCESS,
  ERROR_INVOICES_CREATE,
  ERROR_INVOICES_CREATE_FAIL,
  ERROR_INVOICES_CREATE_RESET,
  ERROR_INVOICES_CREATE_SUCCESS,
  ERROR_INVOICES_DELETE,
  ERROR_INVOICES_DELETE_FAIL,
  ERROR_INVOICES_DELETE_RESET,
  ERROR_INVOICES_DELETE_SUCCESS,
  ERROR_INVOICES_EDIT,
  ERROR_INVOICES_EDIT_FAIL,
  ERROR_INVOICES_EDIT_RESET,
  ERROR_INVOICES_EDIT_SUCCESS,
  ERROR_INVOICES_NOTIFICATION_PROPERTIES_LIST,
  ERROR_INVOICES_NOTIFICATION_PROPERTIES_LIST_FAIL,
  ERROR_INVOICES_NOTIFICATION_PROPERTIES_LIST_RESET,
  ERROR_INVOICES_NOTIFICATION_PROPERTIES_LIST_SUCCESS,
  ERROR_INVOICES_RELEASE,
  ERROR_INVOICES_RELEASE_FAIL,
  ERROR_INVOICES_RELEASE_RESET,
  ERROR_INVOICES_RELEASE_SUCCESS,
  ERROR_INVOICES_SEARCH_INVOICE,
  ERROR_INVOICES_SEARCH_INVOICE_FAIL,
  ERROR_INVOICES_SEARCH_INVOICE_RESET,
  ERROR_INVOICES_SEARCH_INVOICE_SUCCESS,
  ERROR_INVOICES_TYPE_INVOICE_LIST,
  ERROR_INVOICES_TYPE_INVOICE_LIST_FAIL,
  ERROR_INVOICES_TYPE_INVOICE_LIST_RESET,
  ERROR_INVOICES_TYPE_INVOICE_LIST_SUCCESS,
  GET_HISTORY_ERROR_ENVOICE_TRANSFER,
  GET_HISTORY_ERROR_ENVOICE_TRANSFER_FAIL,
  GET_HISTORY_ERROR_ENVOICE_TRANSFER_SUCCESS,
  GET_LIST_ERROR_INVOICES,
  GET_LIST_ERROR_INVOICES_FAIL,
  GET_LIST_ERROR_INVOICES_SUCCESS,
  PREVIEW_PDF_ERROR_INVOICE,
  PREVIEW_PDF_ERROR_INVOICE_FAIL,
  PREVIEW_PDF_ERROR_INVOICE_SUCCESS,
  RESET_DOWNLOAD_XML_ERROR_INVOICES,
  RESET_GET_HISTORY_ERROR_ENVOICE_TRANSFER,
  RESET_LIST_ERROR_INVOICES,
  RESET_PREVIEW_PDF_ERROR_INVOICE,
  RESET_TRANSFER_USB_ERROR_INVOICES,
  SET_COLUMN_VISIBLE_ERROR_INVOICES,
  TRANSFER_USB_ERROR_INVOICES,
  TRANSFER_USB_ERROR_INVOICES_FAIL,
  TRANSFER_USB_ERROR_INVOICES_SUCCESS,
} from "./actionTypes";
// GET_HISTORY_ERROR_ENVOICE_TRANSFER
export const getHistoryErrorTransfer = (id, path) => ({
  type: GET_HISTORY_ERROR_ENVOICE_TRANSFER,
  id,
  path,
});

export const getHistoryErrorTransferSuccess = data => ({
  type: GET_HISTORY_ERROR_ENVOICE_TRANSFER_SUCCESS,
  data,
});

export const getHistoryErrorTransferFail = error => ({
  type: GET_HISTORY_ERROR_ENVOICE_TRANSFER_FAIL,
  error,
});
export const resetGetHistoryErrorTransfer = error => ({
  type: RESET_GET_HISTORY_ERROR_ENVOICE_TRANSFER,
});
export const previewPdfErrorInvoice = (id, path, typePreview = null) => ({
  type: PREVIEW_PDF_ERROR_INVOICE,
  id,
  path,
  typePreview,
});

// PREVIEW_PDF Success
export const previewPdfErrorInvoiceSuccess = data => ({
  type: PREVIEW_PDF_ERROR_INVOICE_SUCCESS,
  data,
});

// previewPdfErrorInvoiceFail
export const previewPdfErrorInvoiceFail = error => ({
  type: PREVIEW_PDF_ERROR_INVOICE_FAIL,
  error,
});

// resetPreviewFile
export const resetPreviewPdfErrorInvoice = () => ({
  type: RESET_PREVIEW_PDF_ERROR_INVOICE,
});
// Thong báo hóa đơn sai sót
export const getListErrorInvoices = (params, showLoading = true) => ({
  type: GET_LIST_ERROR_INVOICES,
  params,
  showLoading,
});

export const getListErrorInvoicesSuccess = (listData, totalCount) => ({
  type: GET_LIST_ERROR_INVOICES_SUCCESS,
  listData,
  totalCount,
});

export const getListErrorInvoicesFail = error => ({
  type: GET_LIST_ERROR_INVOICES_FAIL,
  error,
});

export const resetListErrorInvoices = error => ({
  type: RESET_LIST_ERROR_INVOICES,
});

// show/hide column
export const setColumnVisibleErrorInvoices = (field, value) => ({
  type: SET_COLUMN_VISIBLE_ERROR_INVOICES,
  field,
  value,
});

// DOWNLOAD_XML_REGISTRY_INVOICES
export const downloadXmlErrorInvoices = (
  resource_id,
  fileDownloadName,
  responseType
) => ({
  type: DOWNLOAD_XML_ERROR_INVOICES,
  resource_id,
  fileDownloadName,
  responseType,
});

export const downloadXmlErrorInvoicesSuccess = (
  fileDownloadResponse,
  fileDownload,
  fileDownloadName
) => ({
  type: DOWNLOAD_XML_ERROR_INVOICES_SUCCESS,
  fileDownloadResponse,
  fileDownload,
  fileDownloadName,
});

export const downloadXmlErrorInvoicesFail = error => ({
  type: DOWNLOAD_XML_ERROR_INVOICES_FAIL,
  error,
});
export const resetDownloadXmlErrorInvoices = error => ({
  type: RESET_DOWNLOAD_XML_ERROR_INVOICES,
});

// Create Error Invoices
export const createErrorInvoices = (data = {}) => ({
  type: ERROR_INVOICES_CREATE,
  payload: { data },
});

export const createErrorInvoicesSuccess = data => ({
  type: ERROR_INVOICES_CREATE_SUCCESS,
  payload: data,
});

export const createErrorInvoicesFail = error => ({
  type: ERROR_INVOICES_CREATE_FAIL,
  payload: error,
});

export const resetCreateErrorInvoices = () => ({
  type: ERROR_INVOICES_CREATE_RESET,
  payload: {},
});
// EDIT Error Invoices
export const editErrorInvoices = (data = {}, id) => ({
  type: ERROR_INVOICES_EDIT,
  payload: { data },
  id,
});

export const editErrorInvoicesSuccess = data => ({
  type: ERROR_INVOICES_EDIT_SUCCESS,
  payload: data,
});

export const editErrorInvoicesFail = error => ({
  type: ERROR_INVOICES_EDIT_FAIL,
  payload: error,
});

export const resetEditErrorInvoices = () => ({
  type: ERROR_INVOICES_EDIT_RESET,
  payload: {},
});
// Phát hành hóa đơn sai sót
export const releaseErrorInvoices = id => ({
  type: ERROR_INVOICES_RELEASE,
  id,
});

export const releaseErrorInvoicesSuccess = () => ({
  type: ERROR_INVOICES_RELEASE_SUCCESS,
});

export const releaseErrorInvoicesFail = error => ({
  type: ERROR_INVOICES_RELEASE_FAIL,
  error,
});
export const resetReleaseErrorInvoices = () => ({
  type: ERROR_INVOICES_RELEASE_RESET,
});

// Search Invoice Error Invoices
export const searchInvoiceErrorInvoices = (params = {}) => ({
  type: ERROR_INVOICES_SEARCH_INVOICE,
  payload: { params },
});

export const searchInvoiceErrorInvoicesSuccess = data => ({
  type: ERROR_INVOICES_SEARCH_INVOICE_SUCCESS,
  payload: data,
});

export const searchInvoiceErrorInvoicesFail = error => ({
  type: ERROR_INVOICES_SEARCH_INVOICE_FAIL,
  payload: error,
});

export const resetSearchInvoiceErrorInvoices = () => ({
  type: ERROR_INVOICES_SEARCH_INVOICE_RESET,
  payload: {},
});

// List Type Invoice Error Invoices
export const listTypeInvoiceErrorInvoices = (params = {}) => ({
  type: ERROR_INVOICES_TYPE_INVOICE_LIST,
  payload: { params },
});

export const listTypeInvoiceErrorInvoicesSuccess = data => ({
  type: ERROR_INVOICES_TYPE_INVOICE_LIST_SUCCESS,
  payload: data,
});

export const listTypeInvoiceErrorInvoicesFail = error => ({
  type: ERROR_INVOICES_TYPE_INVOICE_LIST_FAIL,
  payload: error,
});

export const resetListTypeInvoiceErrorInvoices = () => ({
  type: ERROR_INVOICES_TYPE_INVOICE_LIST_RESET,
  payload: {},
});

// List Notification Properties Error Invoices
export const listNotificationPropertiesErrorInvoices = (params = {}) => ({
  type: ERROR_INVOICES_NOTIFICATION_PROPERTIES_LIST,
  payload: { params },
});

export const listNotificationPropertiesErrorInvoicesSuccess = data => ({
  type: ERROR_INVOICES_NOTIFICATION_PROPERTIES_LIST_SUCCESS,
  payload: data,
});

export const listNotificationPropertiesErrorInvoicesFail = error => ({
  type: ERROR_INVOICES_NOTIFICATION_PROPERTIES_LIST_FAIL,
  payload: error,
});

export const resetListNotificationPropertiesErrorInvoices = () => ({
  type: ERROR_INVOICES_NOTIFICATION_PROPERTIES_LIST_RESET,
  payload: {},
});

// transferUsbInvoiceErrors
export const transferUsbInvoiceErrors = (id, typeSend, content) => ({
  type: TRANSFER_USB_ERROR_INVOICES,
  id,
  typeSend,
  content,
});

export const transferUsbInvoiceErrorsSuccess = data => ({
  type: TRANSFER_USB_ERROR_INVOICES_SUCCESS,
  data,
});

export const transferUsbInvoiceErrorsFail = error => ({
  type: TRANSFER_USB_ERROR_INVOICES_FAIL,
  error,
});
export const resetTransferUsbInvoiceErrors = error => ({
  type: RESET_TRANSFER_USB_ERROR_INVOICES,
});

// Xóa thông báo sai sót
export const errorInvoicesDelete = id => ({
  type: ERROR_INVOICES_DELETE,
  id,
});

export const errorInvoicesDeleteSuccess = () => ({
  type: ERROR_INVOICES_DELETE_SUCCESS,
});

export const errorInvoicesDeleteFail = error => ({
  type: ERROR_INVOICES_DELETE_FAIL,
  error,
});
export const resetErrorInvoicesDelete = () => ({
  type: ERROR_INVOICES_DELETE_RESET,
});
